/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SpecialOrderStatus {
    DRAFT = 'DRAFT',
    OPEN = 'OPEN'
}
